import {
  SET_BUILDING_INGEST_STATS,
  SET_POINT_INGEST_MESSAGES,
  SET_POINT_SAMPLE_RATES,
} from './actiontypes';
import { getBuildingIngestStats, getPointSampleRates } from '../../api/Api';

const sendData = (type, data) => ({
  type,
  data,
});

export const getBuildingIngestStatsAction = (interval) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return (
    getBuildingIngestStats(jwt, interval)
      .then((data) => {
        dispatch(sendData(SET_BUILDING_INGEST_STATS, data.buildings));
        dispatch(sendData(SET_POINT_INGEST_MESSAGES, data.points));
      })
      // these calls can fail if the interval is invalid, so catch and do nothing on faiure
      .catch(() => {})
  );
};

export const getPointSampleRatesAction = (buildingId, interval) => (dispatch, getState) => {
  const {
    user: { jwt },
  } = getState();
  return (
    getPointSampleRates(jwt, buildingId, interval)
      .then((data) => dispatch(sendData(SET_POINT_SAMPLE_RATES, data)))
      // this call can fail if the interval is invalid, so catch and do nothing on faiure
      .catch(() => {})
  );
};
